import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';

const ValidateAuth = async (authkey) => {
  // Try to send authorization header to api
  try {
    const headers = {"Authorization": "BEARER authToken=" + authkey}
    const validateResponse = await axios.get('https://infinity.skyspark.nl/api/sys/uiPoll', {headers});
    if(validateResponse.status === 200) return true
    else return false
  } catch {
    return false;
  }
}

// Check if user has authkey; if the key is not present, go to the login page
const AuthChecker =  ({ children }) => {
  const authkey = Cookies.get('skyarc-auth-8080');
  const navigate = useNavigate();
  // Look for changes in authkey, or navigate prop if change is detected check if authkey is still valid otherwise return to login 
  useEffect(() => {
    const checkAuth = async () => {
      const isValid = await ValidateAuth(authkey);  
      if (!isValid) {
        Cookies.remove('skyarc-auth-8080')
        navigate('/');
      }
    };
    checkAuth();
  }, [authkey, navigate]);  

  return children;
};

export default AuthChecker;
